import { apiClient } from '@borradh-workspace/api-client';
import type {
  ClaireReport,
  ReportWindowInput,
} from '@borradh-workspace/api-client/types';
import { claireReportSchema } from '@borradh-workspace/contracts';
import { queryOptions, useQuery } from '@tanstack/react-query';

import { queryKeys } from '@/lib/query-keys';

import { reportSearchParams } from '../../lib/report-window';

export const getClaireReportQueryOptions = (params: ReportWindowInput) =>
  queryOptions({
    queryKey: queryKeys.reports.claire(
      params.from,
      params.to,
      params.locationId
    ),
    queryFn: () =>
      apiClient.get<ClaireReport>(
        `reports/claire?${reportSearchParams(params)}`,
        { schema: claireReportSchema }
      ),
    staleTime: 60 * 1000,
  });

export const useGetClaireReport = (params: ReportWindowInput) => {
  const query = useQuery(getClaireReportQueryOptions(params));
  return {
    report: query.data ?? null,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
};
